import { Component, Input, OnInit } from '@angular/core';
import {
  HANDOVER_STATUS_CREATED,
  HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_7_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_8_OPE_TO_CWO_ID,
  HANDOVER_TYPE_HO1_ID,
  HANDOVER_TYPE_HO2_ID,
  HANDOVER_TYPE_HO5_ID,
  HANDOVER_TYPE_HOAC_ID,
  HANDOVER_TYPE_HOEC_ID,
  HANDOVER_TYPE_IDS_WITH_NOTIFICATIONS,
} from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { UserService } from 'src/app/services/user.service';
import { SectionTouched } from '../shared/section-touched.class';

@Component({
  selector: 'app-handover-detail-status-notifications',
  templateUrl: './handover-detail-status-notifications.component.html',
  styleUrls: ['./handover-detail-status-notifications.component.scss'],
  standalone: false,
})
export class HandoverDetailStatusNotificationsComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;

  displayNotifications = false;
  readOnlyNotifications = false;
  isHOECHOAC = false;
  showExecutiveSummary = false;
  showAbandonmentReport = false;

  constructor(private userService: UserService) {
    super();
  }

  ngOnInit(): void {
    if (this.handover?.handoverTypeId) {
      this.isHOECHOAC =
        this.handover?.handoverTypeId == HANDOVER_TYPE_HOEC_ID ||
        this.handover?.handoverTypeId == HANDOVER_TYPE_HOAC_ID;
      this.showExecutiveSummary =
        this.handover?.handoverTypeId == HANDOVER_TYPE_HO1_ID ||
        this.handover?.handoverTypeId == HANDOVER_TYPE_HO2_ID ||
        this.handover?.handoverTypeAreaReasonId ==
          HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID;
      this.showAbandonmentReport =
        this.handover?.handoverTypeId == HANDOVER_TYPE_HO5_ID;
      this.displayNotifications = HANDOVER_TYPE_IDS_WITH_NOTIFICATIONS.includes(
        this.handover?.handoverTypeId
      );
      this.readOnlyNotifications =
        this.readOnlyContent &&
        !(
          this.handover?.handoverStatusId == HANDOVER_STATUS_CREATED &&
          (this.handover?.handoverTypeAreaReasonId ==
            HANDOVER_TYPE_AREA_REASON_7_CWO_TO_OPE_ID ||
            this.handover?.handoverTypeAreaReasonId ==
              HANDOVER_TYPE_AREA_REASON_8_OPE_TO_CWO_ID) &&
          this.handover?.emmitterId ==
            this.userService.getUserProperties().userId
        );
    }
  }
}
